import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import * as types from '../../types';
import styles from './ReferralPill.module.scss';
import { ReactComponent as ReferralIcon } from '../../assets/images/icons/icon_gift_box.svg';
export default function ReferralPill() {
  const { t } = useTranslation();
  const cart = useSelector((state: types.AppState) => state.storeShop.cart);
  const referrerName = cart.referrerName;

  const titleText = referrerName
    ? t('referrer_name_referral_offer_auto_applied', { referrerName })
    : t('your_referral_offer');

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        <ReferralIcon width={14} height={12} className={styles.icon} />
        {titleText}
      </div>
      <div className={styles.body}>{t('activation_fee_waived_plus_up_to_70_off')}</div>
    </div>
  );
}
